<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.optimizersEditedItem.REFERENCE"
                        label="REFERENCE (*)"
                        :rules="[() => !!$store.state.optimizersEditedItem.REFERENCE || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.optimizersEditedItem.MANUFACTURER"
                        label="MANUFACTURER KEY (*)"
                        :rules="[() => !!$store.state.optimizersEditedItem.MANUFACTURER || 'Ce champ est obligatoire !',
                                 () => ($store.state.optimizersEditedItem.MANUFACTURER.length == 3) || 'Key fabricant (3 caractères)']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-text-field
                        v-model="$store.state.optimizersEditedItem.POWER"
                        label="POWER (W) (*)"
                        :rules="[() => !!$store.state.optimizersEditedItem.POWER || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.optimizersEditedItem.SOG_TYPE"
                        label="ALIAS"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-radio-group
                        v-model="$store.state.optimizersEditedItem.INSTALLATION"                                               column
                        label= "INSTALLATION"
                    >
                        <v-radio
                            label= "INDOOR"
                            key= "INDOOR"
                            value= "INDOOR"
                        ></v-radio>
                        <v-radio
                            label= "OUTDOOR"
                            key= "OUTDOOR"
                            value= "OUTDOOR"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.optimizersEditedItem.OPTIMIZATION"
                        label="OPTIMIZATION"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.optimizersEditedItem.SAFETY"
                        label="SAFETY"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.optimizersEditedItem.MONITORING"
                        label="MONITORING"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.optimizersEditedItem.GATEWAY"
                        label="GATEWAY"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.optimizersEditedItem.CLOUD_CONNECT"
                        label="CLOUD_CONNECT"
                    ></v-checkbox>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireOptimiseurs",
		data: function () {
			return {
            }
        }
    }
</script>
